import { RIcon } from './RIcon';

type Props = {
  title: string;
  on?: boolean;
  onClick?: () => void;
  desc?: string;
  radio?: boolean;
  dashed?: boolean;
  disabled?: boolean;
};

const ROpt = ({ title, on, onClick, desc, radio, dashed, disabled }: Props) => (
  <button
    type="button"
    className={['c-checkopt', on ? 'on' : '', radio ? 'c-checkopt-radio' : '', dashed ? 'dashed' : '']
      .filter(Boolean)
      .join(' ')}
    role={radio ? 'radio' : 'checkbox'}
    aria-checked={!!on}
    disabled={disabled}
    onClick={() => onClick?.()}
  >
    <span className="c-checkopt-box">
      <RIcon.check />
    </span>
    <span className="c-checkopt-body">
      <span className="c-checkopt-title">{title}</span>
      {desc && <span className="c-checkopt-desc">{desc}</span>}
    </span>
  </button>
);

export { ROpt };
